import {RemoteGetHealthFavoriteProviderLocation} from 'data/usecases/private/booking-flow/health/remote-get-health-favorite-provider-location';
import {GetHealthFavoriteProviderLocation} from 'domain/usecases/private/booking-flow/health';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetHealthFavoriteProviderLocation = (): GetHealthFavoriteProviderLocation =>
	new RemoteGetHealthFavoriteProviderLocation(
		makeBFFApiUrl(BookingFlowEndPoints.healthFavoriteProviderLocation),
		makeAuthorizeHttpClientDecorator(),
	);
